import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["tagName", "id", "role", "tabIndex", "onMouseEnter", "onClick", "aria-level", "aria-label", "aria-hidden", "children"];
import styled from 'foundations-theming/utils';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { useH7Context } from '../H7/H7Provider';
import { deepMerge } from '../../utils/deepMerge';
import { usePageHeadingContext } from '../PageHeading/PageHeadingProvider';
import { useTaglineHeadingContext } from '../TaglineHeading/TaglineHeadingProvider';
import { CSS_SPECIFICITY } from '../../constants/CSSSpecificity';
import { jsx as _jsx } from "react/jsx-runtime";
// The `as` prop will determine which element is actually rendered
const StyledHeading = styled.span.withConfig({
  displayName: "Heading__StyledHeading",
  componentId: "sc-1cjiymn-0"
})(({
  $cssStyles,
  $styleOverrides
}) => {
  return deepMerge($styleOverrides, {
    [CSS_SPECIFICITY.FORCE_OVERRIDE]: $cssStyles
  });
});
export const Heading = _ref => {
  var _h7Context$headingSty, _pageHeadingContext$h, _taglineHeadingContex;
  let {
      tagName = 'span',
      id,
      role,
      tabIndex,
      onMouseEnter,
      onClick,
      'aria-level': ariaLevel = 2,
      'aria-label': ariaLabel,
      'aria-hidden': ariaHidden,
      children
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(restProps);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  const h7Context = useH7Context();
  const pageHeadingContext = usePageHeadingContext();
  const taglineHeadingContext = useTaglineHeadingContext();
  return /*#__PURE__*/_jsx(StyledHeading, Object.assign({}, domProps, {
    as: tagName,
    id: id,
    role: role,
    tabIndex: tabIndex,
    onMouseEnter: onMouseEnter,
    onClick: onClick,
    "aria-level": ariaLevel,
    "aria-label": ariaLabel,
    "aria-hidden": ariaHidden,
    $styleOverrides: deepMerge((_h7Context$headingSty = h7Context === null || h7Context === void 0 ? void 0 : h7Context.headingStyleOverrides) !== null && _h7Context$headingSty !== void 0 ? _h7Context$headingSty : {}, (_pageHeadingContext$h = pageHeadingContext === null || pageHeadingContext === void 0 ? void 0 : pageHeadingContext.headingStyleOverrides) !== null && _pageHeadingContext$h !== void 0 ? _pageHeadingContext$h : {}, (_taglineHeadingContex = taglineHeadingContext === null || taglineHeadingContext === void 0 ? void 0 : taglineHeadingContext.headingStyleOverrides) !== null && _taglineHeadingContex !== void 0 ? _taglineHeadingContex : {}),
    $cssStyles: cssStyles,
    children: children
  }));
};